export default value =>
  value
    ? value
        .toString()
        .charAt(0)
        .toUpperCase() + value.slice(1)
    : "";
